/**
 * GENERADO por scratchpad/generar-grupos-variantes.cjs -- no editar a mano.
 * Fuente: WORK-VARIANTES-CANDIDATOS_2026-10-19.json de Atenea (#30203), sha256 89dbf1e07dfb364a371c99d14bbd14419c9a0f954b5474a37d1cfc0c5dc9a5af
 * Catalogo de origen sha256 9d280ab4420e4439d68fc84a6a857dbaad0c624190a7726f936699ac3d09a867 (455 ids).
 *
 * MADERINCO-VARIANTES-PANTALLA-T1: SOLO presentacion. Cada grupo reune registros con el mismo texto, unidad y precio;
 * coincidir no es ser el mismo producto aprobado: todos van "por revisar" (alcance: Josse al probar; lo tecnico, el
 * ingeniero). Nada se borra ni se fusiona en la base; al agregar entra el id exacto de la fuente elegida.
 * Los candidatos por area (1) van como UNA partida (porArea): el area del proyecto no es una talla;
 * se unen aunque el precio difiera y el selector muestra el precio de cada fuente (Ares #30267).
 */
export const GRUPOS_SHA256 = '89dbf1e07dfb364a371c99d14bbd14419c9a0f954b5474a37d1cfc0c5dc9a5af';
export const GRUPOS = [
 {
  "id": "igual-001",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A15",
   "1347:PRESUPUESTO CASA:A14"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-002",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B13",
   "1346:PRESUPUESTO - 1D:B13"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-003",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B14",
   "1346:PRESUPUESTO - 1D:B14"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-004",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B16",
   "1346:PRESUPUESTO - 1D:B16"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-005",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B17",
   "1346:PRESUPUESTO - 1D:B17"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-006",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1D:B18",
   "1346:PRESUPUESTO - HALL:B26"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-007",
  "fuenteIds": [
   "1347:PRESUPUESTO CASA:A13",
   "4546:PRESUPUESTO CASA:A13"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-008",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B43",
   "1346:PRESUPUESTO - 1D:B44"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-009",
  "fuenteIds": [
   "1346:PRESUPUESTO - HALL:B17",
   "1346:PRESUPUESTO - 1C:B82",
   "1346:PRESUPUESTO - 1D:B79"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-010",
  "fuenteIds": [
   "1346:PRESUPUESTO - HALL:B23",
   "1346:PRESUPUESTO - 1C:B100",
   "1346:PRESUPUESTO - 1C:B127"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-011",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A83",
   "1347:PRESUPUESTO CASA:A64"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-012",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A84",
   "1347:PRESUPUESTO CASA:A65"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-013",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A85",
   "1347:PRESUPUESTO CASA:A66"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-014",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A86",
   "1347:PRESUPUESTO CASA:A67"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-015",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A87",
   "1347:PRESUPUESTO CASA:A68"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-016",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A88",
   "1347:PRESUPUESTO CASA:A69"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-017",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A89",
   "1347:PRESUPUESTO CASA:A70"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-018",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A90",
   "1347:PRESUPUESTO CASA:A71"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-019",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A91",
   "1347:PRESUPUESTO CASA:A72"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-020",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A92",
   "1347:PRESUPUESTO CASA:A73"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-021",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B101",
   "1346:PRESUPUESTO - 1D:B97"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-022",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B102",
   "1346:PRESUPUESTO - 1D:B98"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-023",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B97",
   "1346:PRESUPUESTO - 1D:B93"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-024",
  "fuenteIds": [
   "1347:PRESUPUESTO CASA:A76",
   "1342:PRESUPUESTO CASA:A99"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-025",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B107",
   "1346:PRESUPUESTO - 1D:B103"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-026",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B108",
   "1346:PRESUPUESTO - 1D:B104"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-027",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B109",
   "1346:PRESUPUESTO - 1D:B105"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-028",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B110",
   "1346:PRESUPUESTO - 1D:B106"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-029",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B111",
   "1346:PRESUPUESTO - 1D:B107"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-030",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B112",
   "1346:PRESUPUESTO - 1D:B108"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-031",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B113",
   "1346:PRESUPUESTO - 1D:B109"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-032",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B114",
   "1346:PRESUPUESTO - 1D:B110"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-033",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B115",
   "1346:PRESUPUESTO - 1D:B111"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-034",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B116",
   "1346:PRESUPUESTO - 1D:B112"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-035",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B117",
   "1346:PRESUPUESTO - 1D:B113"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-036",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B118",
   "1346:PRESUPUESTO - 1D:B114"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-037",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B119",
   "1346:PRESUPUESTO - 1D:B115"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-038",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B120",
   "1346:PRESUPUESTO - 1D:B116"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-039",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B121",
   "1346:PRESUPUESTO - 1D:B117"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-040",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B122",
   "1346:PRESUPUESTO - 1D:B118"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-041",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1D:B121",
   "1346:PRESUPUESTO - 1C:B130"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-042",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A25",
   "1347:PRESUPUESTO CASA:A22"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-043",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B20",
   "1346:PRESUPUESTO - 1D:B21"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-044",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B21",
   "1346:PRESUPUESTO - 1D:B22"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-045",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B22",
   "1346:PRESUPUESTO - 1D:B23"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-046",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B23",
   "1346:PRESUPUESTO - 1D:B24"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-047",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B24",
   "1346:PRESUPUESTO - 1D:B25"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-048",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B25",
   "1346:PRESUPUESTO - 1D:B26"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-049",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B26",
   "1346:PRESUPUESTO - 1D:B27"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-050",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B29",
   "1346:PRESUPUESTO - 1D:B30"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-051",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B30",
   "1346:PRESUPUESTO - 1D:B31"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-052",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B33",
   "1346:PRESUPUESTO - 1D:B34"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-053",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B34",
   "1346:PRESUPUESTO - 1D:B35"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-054",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B35",
   "1346:PRESUPUESTO - 1D:B36"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-055",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B36",
   "1346:PRESUPUESTO - 1D:B37"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-056",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B37",
   "1346:PRESUPUESTO - 1D:B38"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-057",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B38",
   "1346:PRESUPUESTO - 1D:B39"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-058",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B39",
   "1346:PRESUPUESTO - 1D:B40"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-059",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B40",
   "1346:PRESUPUESTO - 1D:B41"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-060",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B46",
   "1346:PRESUPUESTO - 1D:B47"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-061",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B47",
   "1346:PRESUPUESTO - 1D:B48"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-062",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B48",
   "1346:PRESUPUESTO - 1D:B49"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-063",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B49",
   "1346:PRESUPUESTO - 1D:B50"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-064",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B50",
   "1346:PRESUPUESTO - 1D:B51"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-065",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B54",
   "1346:PRESUPUESTO - 1D:B55"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-066",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B74",
   "1346:PRESUPUESTO - 1D:B73"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-067",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B76",
   "1346:PRESUPUESTO - 1D:B71"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-068",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B79",
   "1346:PRESUPUESTO - 1D:B76"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-069",
  "fuenteIds": [
   "1347:PRESUPUESTO CASA:A58",
   "1342:PRESUPUESTO CASA:A76"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-070",
  "fuenteIds": [
   "1347:PRESUPUESTO CASA:A59",
   "1342:PRESUPUESTO CASA:A78"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-071",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B83",
   "1346:PRESUPUESTO - 1D:B80"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-072",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B85",
   "1346:PRESUPUESTO - 1D:B81"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-073",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B86",
   "1346:PRESUPUESTO - 1D:B82"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-074",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B91",
   "1346:PRESUPUESTO - 1D:B87"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-075",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B92",
   "1346:PRESUPUESTO - 1D:B88"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-076",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B93",
   "1346:PRESUPUESTO - 1D:B89"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-077",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B94",
   "1346:PRESUPUESTO - 1D:B90"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "igual-078",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B139",
   "1346:PRESUPUESTO - 1D:B130"
  ],
  "estado": "candidato_revision_alcance",
  "precioConocido": true
 },
 {
  "id": "area-001",
  "fuenteIds": [
   "1346:PRESUPUESTO - 1C:B12",
   "1346:PRESUPUESTO - 1D:B12"
  ],
  "estado": "candidato_area_del_proyecto",
  "porArea": true
 }
];
